import React from "react";
import "./About.css";
import {
  EmpathyIcon,
  RespectIcon,
  SupportIcon,
  GrowthIcon,
} from "../components/ValueIcons";

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero section">
        <div className="container">
          <h1 className="section-title">About Passion Care 4 U</h1>
          <div className="about-intro">
            <p className="intro-text">
              Passion Care 4 U Global is a premier consultancy and training
              organization specializing in short courses and workshops. We are
              committed to empowering individuals through practical education
              and hands-on training.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section section">
        <div className="container">
          <h2 className="section-title">Our Core Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <EmpathyIcon />
              </div>
              <h3>Empathy</h3>
              <p>
                We approach every client and student with understanding and
                compassion, recognizing individual needs and circumstances.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <RespectIcon />
              </div>
              <h3>Respect</h3>
              <p>
                We treat everyone with dignity and value diverse perspectives in
                our training and community work.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <SupportIcon />
              </div>
              <h3>Tailored Support</h3>
              <p>
                We provide personalized guidance and support to ensure every
                individual achieves their learning goals.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <GrowthIcon />
              </div>
              <h3>Growth</h3>
              <p>
                We foster personal and professional development through
                practical, hands-on learning experiences.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Company Info Section */}
      <section className="company-info-section section">
        <div className="container">
          <div className="company-info-grid">
            <div className="info-card">
              <div className="info-card-image">
                <img
                  src="/images/medical-practical.jpg"
                  alt="Team collaboration"
                />
              </div>
              <h3>Who We Are</h3>
              <p>
                Passion Care 4 U Global provides consulting and training in
                specialized short courses and workshops. We combine theoretical
                knowledge with practical application to ensure comprehensive
                skill development.
              </p>
            </div>
            <div className="info-card">
              <div className="info-card-image">
                <img src="/images/nurses.jpg" alt="Community service" />
              </div>
              <h3>Community Commitment</h3>
              <p>
                We engage in community voluntary work after training, offering
                practical experience on a voluntary basis. This practical
                component is compulsory with our training programs and is
                integral to our educational approach.
              </p>
            </div>
            <div className="info-card">
              <div className="info-card-image">
                <img src="/images/graduates01.jpg" alt="Career development" />
              </div>
              <h3>Career Support</h3>
              <p>
                We provide comprehensive job placement assistance through dual
                sponsorship pathways. Self-sponsorship options are available for
                those with personal funding, and free sponsorship opportunities
                for eligible candidates and graduates.
              </p>
            </div>
            <div className="info-card">
              <div className="info-card-image">
                <img src="/images/meeting01.jpg" alt="Inclusive education" />
              </div>
              <h3>Inclusive Education</h3>
              <p>
                We welcome all individuals with a Matric certificate or
                equivalent. Our only requirements are the ability to read,
                write, and communicate effectively - there are no minimum
                academic requirements beyond this.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Courses Section */}
      <section className="additional-courses section">
        <div className="container">
          <h2 className="section-title">Additional Training Areas</h2>
          <p className="section-subtitle">
            Beyond our core programs, we also offer specialized training in:
          </p>

          <div className="additional-courses-list">
            <div className="course-item">
              <h4>Event Planning</h4>
              <p>
                Comprehensive training in organizing both corporate and
                non-corporate events, from concept to execution.
              </p>
            </div>
            <div className="course-item">
              <h4>Corporate Event Management</h4>
              <p>
                Specialized training for professional corporate event planning
                and management.
              </p>
            </div>
            <div className="course-item">
              <h4>Foundation & Charity Work</h4>
              <p>
                Training for those interested in establishing or working with
                charitable foundations and community organizations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Training Approach Section */}
      <section className="approach-section section">
        <div className="container">
          <h2 className="section-title">Our Training Approach</h2>
          <div className="approach-steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Theoretical Foundation</h3>
                <p>
                  Comprehensive online or in-person theoretical training with
                  detailed manual books provided for all courses.
                </p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Practical Application</h3>
                <p>
                  Hands-on practical training conducted physically to ensure
                  real-world skill development and competency.
                </p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Community Integration</h3>
                <p>
                  Voluntary community work that provides practical experience
                  while contributing positively to society.
                </p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Career Transition</h3>
                <p>
                  Job placement assistance through various sponsorship models to
                  help graduates secure employment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
